var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChooseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.635,
    height: 17.171,
    viewBox: "0 0 16.635 17.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23651",
    "data-name": "Group 23651",
    transform: "translate(-448.096 -330.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43077",
    "data-name": "Path 43077",
    d: "M464.7,331.678a1.156,1.156,0,0,0-1.145-.6q-7.159.024-14.318,0a1.167,1.167,0,0,0-1.142.6c0-.769,0-.769.772-.769,5.084,0,10.169.009,15.253-.014.5,0,.687.1.581.591A.933.933,0,0,0,464.7,331.678Z",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43078",
    "data-name": "Path 43078",
    d: "M618.706,379.664c-.153-.1-.094-.26-.094-.395q0-4.527,0-9.053c0-.153-.053-.324.094-.449Z",
    transform: "translate(-154.006 -35.111)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43079",
    "data-name": "Path 43079",
    d: "M448.1,370.76c.148.125.094.3.094.449q0,4.452,0,8.9c0,.152.058.324-.094.447Z",
    transform: "translate(0 -36.008)",
    fill: "#0e0e0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43080",
    "data-name": "Path 43080",
    d: "M618.593,346.961a4.39,4.39,0,0,1,0-2.018Z",
    transform: "translate(-153.893 -12.689)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43081",
    "data-name": "Path 43081",
    d: "M464.7,332.708c-.24-.61-.327-.672-1-.672q-7.305,0-14.611,0c-.67,0-.756.061-1,.672v3.075a.6.6,0,0,1,.048.373q0,4.528,0,9.056a.6.6,0,0,1-.048.373v.1c.194.573.669.689,1.188.7.8.018,1.607.03,2.409,0,.611-.025,1.154.023,1.484.627a.758.758,0,0,0,.213.193,4.243,4.243,0,0,0,4.98.51.514.514,0,0,1,.716.1c.363.384.744.752,1.121,1.122a.841.841,0,0,0,.685.151.568.568,0,0,0,.458-.849,1.5,1.5,0,0,0-.3-.371c-.338-.342-.685-.676-1.019-1.021-.087-.09-.221-.184-.175-.319.058-.171.24-.129.376-.131.787-.008,1.575,0,2.362-.005a7.655,7.655,0,0,0,1.2-.039.979.979,0,0,0,.905-.669v-.1a.6.6,0,0,1-.048-.373q0-4.576,0-9.152a.6.6,0,0,1,.048-.373V335.3a8.251,8.251,0,0,1,0-2.018Zm-8.5,14.316a2.99,2.99,0,1,1,.072-5.979,2.99,2.99,0,0,1-.072,5.979Zm6.978-1.925c-.962-.027-1.925-.009-2.894-.009a4.161,4.161,0,1,0-8.145-.445c.06.352-.005.472-.393.453-.706-.035-1.415-.022-2.122,0-.279.007-.395-.044-.393-.36q.021-4.177.005-8.354c0-.291.105-.331.36-.331q6.8.01,13.6,0c.312,0,.364.1.363.379q-.015,4.129,0,8.258C463.563,344.972,463.525,345.11,463.177,345.1Zm.307-10.252c-.234.231-.732.066-1.114.068-1.979.007-3.958,0-5.937,0-2.252,0-4.5-.009-6.757.01-.364,0-.486-.086-.439-.445.052-.406-.18-.951.1-1.189.236-.2.764-.073,1.163-.073,4.183,0,8.366.007,12.549-.014.446,0,.561.128.512.535C463.515,334.118,463.717,334.617,463.484,334.848Z",
    transform: "translate(0 -1.031)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseIcon);
export default __webpack_public_path__ + "static/media/ChooseIcon.e53c89c35d3b18eab83081a4ebea62bf.svg";
export { ForwardRef as ReactComponent };